<style scoped>
    @import "./index.css";
</style>
<template>
    <div id="layout-container">

        <Tabs type="card" value="1">
            <TabPane label="常见问题" name="1"></TabPane>
        </Tabs>

        <!--列表-->
        <DragableTable
                refs="table"
                :loading="loading"
                :columns-list="columns"
                v-model="data"
        ></DragableTable>
        <!--列表 end-->
        <!--分页-->
        <Row id="tf-page" type="flex" align="middle" justify="space-between">
            <Col></Col>
            <Col>
                <Page :total="total" :page-size="pageSize" @on-change="onChangePage" @on-page-size-change="onChangeSizePage" show-elevator show-sizer></Page>
            </Col>
        </Row>
        <!--分页 end-->

        <!--右侧弹出窗口-->
        <Drawer :title="winTitle" width="500" v-model="show">
            <div v-html="content" id="tf-content"></div>
        </Drawer>
    </div>

</template>

<script>
    import { DragableTable } from "@/views/Components/Table";

    export default {
        name: "add",
        components: {
            DragableTable
        },
        data() {
            return {
                loading:true,
                columns: [
                    {
                        title: "标题",
                        align:'left',
                        key: "questionCont"
                    },
                    {
                        title: "操作",
                        align: "center",
                        render: (h, params) => {
                            return [
                                //编辑
                                h("Button", {
                                    props: {
                                        icon: "ios-search",
                                        type: "primary",
                                        size: 'small'
                                    },
                                    nativeOn: {
                                        click: () => {
                                            this.showCon(params)
                                        }
                                    }
                                })
                            ];
                        }
                    }
                ],
                data: [],

                //侧边弹出+步骤索引
                show:false,
                winTitle: "查看详情",
                content:'',

                //分页
                pageNum:1,
                pageSize:10,
                total:0
            };
        },
        created(){
            this.getData();
        },
        methods: {
            onChangePage(val){
                this.pageNum = val;
                this.getData();
            },
            onChangeSizePage(val){
                this.pageSize = val;
                this.getData();
            },
            //获取数据
            getData(){
                let that = this;
                this.loading = true;
                that.$func.ajax('questions',{
                    token :that.$func.getToken(),
                    pageNum: that.pageNum,
                    pageSize: that.pageSize,
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.data  = r.pageInfo.list;
                        that.total = r.pageInfo.total;
                        that.loading = false;
                    }
                })
            },
            //查看
            showCon(params) {
                let that = this;
                that.show = true;
                that.winTitle = params.row.questionCont;
                that.content = '';
                //获取详情
                that.$func.ajax('question',{
                    token :that.$func.getToken(),
                    questionId:params.row.questionId
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.content  = r.type.answerCont;
                    }
                })
            }
        }
    };
</script>
